import React from "react";
import { SideMenu, BackHeader } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Countries from "./../../../data/countries";
import Months from "./../../../data/months";
import Date from "./../../../data/date";
import Years from "./../../../data/years";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { BsPlusLg } from "react-icons/bs";
import { useNavigate, useLocation } from "react-router-dom";
const Input = styled("input")({
  display: "none",
});
const TutorAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [countryCode, setCountryCode] = React.useState("");
  const handleDropdownChange = (e) => {
    setCountryCode(e.target.value);
  };
  const State = [
    {
      title: "Balochistan",
    },
    {
      title: "Punjab",
    },
    {
      title: "Sindh",
    },
    {
      title: "KPK",
    },
  ];
  return (
    <SideMenu>
      <div className="page-details-container">
        <BackHeader backHanler={() => navigate(-1)} />
        <p className="page-form-heading">
          {location.state.type === "add" ? "Add Tutor" : "Edit Tutor"}
        </p>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">First name</p>
                <input type="text" className="input" placeholder="First name" />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Last name</p>
                <input type="text" className="input" placeholder="Last name" />
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Email Address</p>
                <input
                  type="email"
                  className="input"
                  placeholder="Email Address"
                />
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Tutor Role</p>
                <input
                  type="text"
                  className="input"
                  placeholder="Enter tutor role"
                />
              </div>
            </Grid>
          </Grid>
          <p className="input-heading">birthdate</p>
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div>
                <select className="input">
                  <option value="">Month</option>
                  {Months.map((monthValue, monthIndex) => {
                    return (
                      <option key={monthIndex} value={monthValue.monthName}>
                        {monthValue.monthName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div>
                <select className="input">
                  <option value="">Date</option>
                  {Date.map((dateValue, dateIndex) => {
                    return (
                      <option key={dateIndex} value={dateValue.date}>
                        {dateValue.date}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
              <div>
                <select className="input">
                  <option value="">Year</option>
                  {Years.map((yearValue, yearIndex) => {
                    return (
                      <option key={yearIndex} value={yearValue.year}>
                        {yearValue.year}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Gender</p>
                <select className="input">
                  <option value="">Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Language</p>
                <select className="input">
                  <option value="">Language</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Country</p>
                <select className="input">
                  <option value="">Country</option>
                  {Countries.map((countriesValue, countriesIndex) => {
                    return (
                      <option key={countriesIndex} value={countriesValue.name}>
                        {countriesValue.name}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">State</p>
                <select className="input">
                  <option value="">State</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">City</p>
                <select className="input">
                  <option value="">City</option>
                  {State.map((stateValue, stateIndex) => {
                    return (
                      <option key={stateIndex} value={stateValue.title}>
                        {stateValue.title}
                      </option>
                    );
                  })}
                </select>
              </div>
            </Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <div>
                <p className="input-heading">Mobile Number</p>
                <div className="country-code-picker-main">
                  <div className="country-code-picker-dropdown-main">
                    <select
                      className="country-code-picker-dropdown"
                      onChange={handleDropdownChange}
                    >
                      <option value="">Select</option>
                      {Countries.map((countriesValue, countriesIndex) => {
                        return (
                          <option
                            key={countriesIndex}
                            value={countriesValue.alpha2Code}
                          >
                            {`${countriesValue.callingCode}  ${countriesValue.name}`}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="country-flag-main">
                    {Countries.map((countriesFlagValue, countriesFlagIndex) => {
                      return (
                        <div key={countriesFlagIndex}>
                          {countriesFlagValue.alpha2Code === countryCode && (
                            <img
                              src={countriesFlagValue.flag}
                              className="country-flag"
                            />
                          )}
                        </div>
                      );
                    })}

                    <input
                      type="number"
                      className="mobile-number-input"
                      placeholder="Enter your mobile number"
                    />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
          <br />
          <Grid container spacing={2}>
            <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
              <div>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
                <p className="upload-file-requirements">
                  (Upload only png,jpg,pdf)
                </p>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
              <div>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
                <p className="upload-file-requirements">
                  (Upload only png,jpg,pdf)
                </p>
              </div>
            </Grid>
            <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
              <div>
                <label htmlFor="icon-button-file">
                  <Input accept="image/*" id="icon-button-file" type="file" />
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    className="icon-button-file"
                  >
                    <BsPlusLg color="#7C7C7C" size={30} />
                  </IconButton>
                </label>
                <p className="upload-file-requirements">
                  (Upload only png,jpg,pdf)
                </p>
              </div>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
            <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
              <Button
                className="form-button"
                variant="text"
                onClick={() => navigate(-1)}
              >
                Submit
              </Button>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}></Grid>
          </Grid>
        </Box>
      </div>
    </SideMenu>
  );
};
export default TutorAdd;
